import initDepotSingleMaps from './modules/depot-single-map';

function boot() {
  initDepotSingleMaps();
}

if (typeof google !== 'undefined' && google.maps) {
  boot();
} else {
  window.addEventListener('load', boot);
}
